module.exports = __webpack_public_path__ + "static/media/TxBaixa.92a99d46.svg";


//////////////////
// WEBPACK FOOTER
// ./src/img/TxBaixa.svg
// module id = 214
// module chunks = 0